import React, { useMemo } from 'react'

import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import * as styles from './Keyboard.styles'

interface KeyboardButtonProps {
  button: FlowChartButton
  isLast: boolean
  isFirst: boolean
}

export const KeyboardButton = ({ button, isLast, isFirst }: KeyboardButtonProps) => {
  const style: React.CSSProperties = useMemo(() => {
    if (isFirst && !isLast) {
      return {
        ...styles.ButtonWrapper,
        ...styles.ButtonWrapperFirst,
      }
    }

    if (isLast && !isFirst) {
      return {
        ...styles.ButtonWrapper,
        ...styles.ButtonWrapperLast,
      }
    }

    return styles.ButtonWrapper
  }, [isFirst, isLast])

  return (
    <view key={button.id} style={style}>
      <Button button={button} />
    </view>
  )
}
